@if ((appState$ | async)?.session; as userSession) {
  <div class="flex-row-center cursor-pointer" [matMenuTriggerFor]="menu">
    <div>
      {{ userSession.user.name }}
    </div>

    <fa-icon class="ms-2" [icon]="faChevronDown" />
  </div>

  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="logoutAsync()">
      <fa-icon [icon]="faRightFromBracket" class="me-2" />
      Log out
    </button>
  </mat-menu>
} @else {
  <div class="flex-row-center">
    <button mat-button [routerLink]="RouteLocations.Login.absoluteUrl">Sign In</button>

    <button
      mat-stroked-button
      [routerLink]="RouteLocations.Login.absoluteUrl"
      [queryParams]="{ register: '1' }"
      class="ms-2"
    >
      Sign Up
    </button>
  </div>
}
